export default "__VITE_ASSET__DsFWnWpT__"